module.exports = __webpack_public_path__ + "media/images/icons/vector_left-04008030157b425707be8b8eee0d502b.svg";